import Stack from "@mui/material/Stack";
import { useStyles } from "./styles";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { forgotPassword } from "../../services/sessions";
import { useMutation } from "react-query";
import { useToast } from "../../hooks/useToast";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";

export function RecoverPassword() {
  const [email, setEmail] = useState("");
  const [disabled, setDisabled] = useState(true);
  const [loading, setLoading] = useState(false);

  const styles = useStyles();
  const toast = useToast();

  const navigate = useNavigate();

  useEffect(() => {
    if (!email) setDisabled(true);
    else {
      setDisabled(false);
    }
  }, [email]);

  const newForgotPassword = useMutation(
    async ({ email, redirect }: { email: string; redirect: string }) => {
      toast.show("Enviando informações...", {
        severity: "info",
      });
      const response = await forgotPassword({ email, redirect });
      return response;
    },
    {
      onSuccess: () => {
        toast.show("Email enviado, verifique sua caixa de mensagens!", {
          severity: "success",
        });
      },
      onError: () => {
        toast.show("Erro ao enviar email!", {
          severity: "error",
        });
      },
    }
  );

  async function handleSubmit() {
    try {
      setLoading(true);
      setDisabled(true);
      await newForgotPassword.mutateAsync({
        email,
        redirect:
          window.location.hostname === "localhost"
            ? "http://localhost:3000/reset/"
            : "https://plus.datasales.info/reset/",
      });
      navigate("/");
    } catch (err) {
      console.log({ err });
    } finally {
      setLoading(false);
      setDisabled(false);
    }
  }

  return (
    <Stack spacing={2} alignItems="center">
      <Paper className={styles.paper} elevation={0} variant="outlined">
        <Stack py={2} px={4} spacing={2} alignItems="center">
          <Typography variant="h5">Recuperar senha</Typography>
          <TextField
            type="email"
            size="small"
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email"
            name="email"
            autoComplete="email"
            autoFocus
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
          <Stack width="100%" direction="row" justifyContent="space-around">
            <Button
              color="primary"
              onClick={() => {
                navigate("/");
              }}
            >
              Cancelar
            </Button>
            <Button
              disabled={disabled}
              variant="contained"
              color="primary"
              onClick={handleSubmit}
            >
              {loading ? (
                <CircularProgress size={26} color="inherit" />
              ) : (
                "Recuperar"
              )}
            </Button>
          </Stack>
        </Stack>
      </Paper>
    </Stack>
  );
}
